import {
  Component,
  createRef,
  useState,
  useEffect
} from 'react'
import _ from 'lodash'
import { Icon } from '@vzmi/shp_shared_compo'
import { createI13nNode } from '@vzmi/ec-react-i13n'
import { Anchor } from 'antd'
import styles from './OperatingDashboard.css'

import { sendI13nClickEvent } from '../../../lib/i13nUtil'
import Reminder from './Reminder'
import DashboardReminder from './DashboardReminder'
import Section from '../Common/NewDashboard/Section/Section'
import NoPrivilegedPermission from '../Common/NoPrivilegedPermission'
import SaleRanking from './OperatingDashboard/SaleRanking'
import SalesPerformance from './OperatingDashboard/SalesPerformance/SalesPerformance'
import SaleStat from './OperatingDashboard/SaleStat'
import BestsellerRanking from './OperatingDashboard/BestsellerRanking/BestsellerRanking'
import CustomerInterest from './OperatingDashboard/CustomerInterest/CustomerInterest'
import PageViewsAnalysis from './OperatingDashboard/PageViewsAnalysis/PageViewsAnalysis'
import SearchKeywords from './OperatingDashboard/SearchKeywords/SearchKeywords'
import MemberAnalyses from './OperatingDashboard/MemberAnalyses/MemberAnalyses'
import BrandAnalysis from './OperatingDashboard/BrandAnalysis'
import ReturnsAnalysis from './OperatingDashboard/ReturnsAnalysis/ReturnsAnalysis'
import WarehouseOverview from './OperatingDashboard/WarehouseOverview'
import CustomFollow from './OperatingDashboard/CustomFollow/CustomFollow'
import {
  GA_CLICK_ACTION,
  getI13nModel
} from './OperatingDashboard.ga'
import ContentWithSubSideBar from '../Common/HorizontalLayout/ContentWithSubSideBar'
import SideBar from '../Common/HorizontalLayout/SideBar'
import { scrollToElement } from '../../../lib/renderUtil'
import { CUSTOMER_INTEREST_SUB_ITEMS } from './constants'

const { Link } = Anchor

export const ANCHOR_MAP = {
  SALE_RANKING: {
    link: 'saleRanking',
    linkTitle: '業績排名',
    sectionTitle: '業績排名'
  },
  SALES_PERFORMANCE: {
    link: 'salesPerformance',
    linkTitle: '即時業績',
    sectionTitle: '即時業績'
  },
  SALE_STAT: {
    link: 'saleStat',
    linkTitle: '訂購概況',
    sectionTitle: '訂購概況'
  },
  BESTSELLER_RANKING: {
    link: 'bestsellerRanking',
    linkTitle: '熱門賣場',
    sectionTitle: '熱門賣場排行'
  },
  CUSTOMER_INTEREST: {
    link: 'customerInterest',
    linkTitle: '買家有興趣',
    sectionTitle: '買家有興趣',
    subItems: CUSTOMER_INTEREST_SUB_ITEMS
  },
  PAGE_VIEWS_ANALYSIS: {
    link: 'pageViewsAnalysis',
    linkTitle: '瀏覽量分析',
    sectionTitle: '瀏覽量分析'
  },
  SEARCH_KEYWORDS: {
    link: 'searchKeywords',
    linkTitle: '熱門關鍵字',
    sectionTitle: '站內熱門關鍵字'
  },
  MEMBER_ANALYSES: {
    link: 'memberAnalyses',
    linkTitle: '會員分析',
    sectionTitle: '會員分析',
    highlight: false
  },
  BRAND_ANALYSIS: {
    link: 'brandAnalysis',
    linkTitle: '品牌分析',
    sectionTitle: '品牌分析'
  },
  RETURNS_ANALYSIS: {
    link: 'returnsAnalysis',
    linkTitle: '退貨分析',
    sectionTitle: '退貨分析'
  },
  CUSTOM_FOLLOW: {
    link: 'customFollow',
    linkTitle: '自訂追蹤賣場',
    sectionTitle: '自訂追蹤賣場'
  },
  WAREHOUSE_OVERVIEW: {
    link: 'warehouseOverview',
    linkTitle: '快倉總覽',
    sectionTitle: '快倉總覽'
  }
}

const DEFAULT_ANCHOR_CLICK_GA = {
  category: 'supplierCenter',
  action: 'center_supplierDashboard'
}

const SECRET_ANCHOR_CLICK_GA = {
  category: 'OT',
  action: '371_supplierDashboard'
}

const SUB_SIDE_BAR_ITEMS = _.map(
  [
    ANCHOR_MAP.SALE_RANKING,
    ANCHOR_MAP.SALES_PERFORMANCE,
    ANCHOR_MAP.SALE_STAT,
    ANCHOR_MAP.BESTSELLER_RANKING,
    ANCHOR_MAP.CUSTOMER_INTEREST,
    ANCHOR_MAP.PAGE_VIEWS_ANALYSIS,
    ANCHOR_MAP.SEARCH_KEYWORDS,
    ANCHOR_MAP.MEMBER_ANALYSES,
    ANCHOR_MAP.BRAND_ANALYSIS,
    ANCHOR_MAP.RETURNS_ANALYSIS,
    ANCHOR_MAP.CUSTOM_FOLLOW,
    ANCHOR_MAP.WAREHOUSE_OVERVIEW
  ],
  anchor => {
    const { link, linkTitle, subItems, highlight } = anchor
    return {
      label: (
        <Link
          href={`#${link}`}
          title={linkTitle}
          subItems={subItems}
        >
          {highlight && (
            <Icon
              name={'ec-flash'}
              size={28}
              color="#FFDE00"
              className={styles.hightlightIcon}
            />
          )}
        </Link>
      )
    }
  }
)

const SubSideBar = props => {
  const { onClick } = props
  const [defaultSelected, setDefaultSelected] = useState(null)
  const { hash } = _.get(global.window, 'location', {})

  const onSelect = selectProps => {
    onClick(selectProps)
  }

  const onAnchorChange = link => {
    if (_.isEmpty(link)) {
      return
    }

    window.history.replaceState(undefined, undefined, link)
  }

  useEffect(() => {
    if (defaultSelected === hash) {
      return
    }

    setDefaultSelected(hash)
  }, [hash, defaultSelected])

  return (
    <Anchor
      affix={false}
      // 選擇 item 後要移至目標距離畫面頂端多遠
      targetOffset={0}
      onChange={onAnchorChange}
    >
      <SideBar
        items={SUB_SIDE_BAR_ITEMS}
        onSelect={onSelect}
        defaultSelected={defaultSelected}
      />
    </Anchor>
  )
}

export class NoPermissionOperatingDashboard extends Component {
  render () {
    return (
      <section>
        <NoPrivilegedPermission />
        <div className={styles.reminderContainer}>
          <Reminder />
        </div>
      </section>
    )
  }
}

class OperatingDashboard extends Component {
  constructor (props) {
    super(props)
    this.dashboardArea = createRef()

    /**
     * if params contains `to=xxx` which is one of ANCHOR_MAP
     * then delayed 1500ms and run scrollToElement to its element
     */
    if (typeof window !== 'undefined') {
      const { location: { search: params } } = props
      const searchParamsObj = new URLSearchParams(params)
      const scrollTo = searchParamsObj.get('to')

      if (scrollTo &&
        Object.values(ANCHOR_MAP).map(e => e.link).includes(scrollTo)) {
        setTimeout(() => {
          scrollToElement(document.querySelector(`#${scrollTo}`))
        }, 1500)
      }
    }
  }

  handleAnchorClick = (selectProps) => {
    const { key = '', keyPath = [] } = selectProps
    const i13nModel = getI13nModel({
      type: GA_CLICK_ACTION.ANCHOR,
      payload: keyPath.length === 2 ? keyPath[1] : key,
      subItemKey: keyPath.length === 2 && keyPath[0]
    })
    this.sendDashboardPageview(i13nModel)
  }

  getIsSecretDashboard = () => {
    return this.props.pageKey === 'SecretDashboard'
  }

  sendDashboardPageview = (i13nModel = {}, e) => {
    if (!_.get(i13nModel, 'label')) {
      return
    }

    const { i13n } = this.props
    const defaultGAConfig = this.getIsSecretDashboard()
      ? SECRET_ANCHOR_CLICK_GA
      : DEFAULT_ANCHOR_CLICK_GA
    const currentI13nModel = {
      ...defaultGAConfig,
      ...i13nModel
    }
    sendI13nClickEvent({ i13n, i13nModel: currentI13nModel, e })
  }

  render () {
    const {
      supplier,
      actions,
      page,
      flags
    } = this.props
    const {
      sharedLink,
      dashboard: { saleStat }
    } = supplier

    const {
      updateSaleStatSettings,
      fetchRankingsStats,
      fetchSaleStats,
      fetchOrderCategoryDistribution,
      fetchPaginationBestsellers,
      fetchWarehouseOverview,
      fetchBrandDistribution,
      fetchBrandDistributionByBrandId,
      fetchSalesPerformances,
      fetchSearchKeywords,
      fetchSpecificSearchKeywordListings,
      fetchListingPageViews,
      fetchReturns,
      fetchReturnReasonSummaries,
      fetchSpecificReturnReasonsListings,
      fetchAbandonedCarts,
      fetchArrivalNoticeSummaries,
      fetchListingTags,
      fetchMemberAnalyses,
      fetchSaleStatsByDate,
      fetchListings,
      fetchTrackListings,
      createTrackListings,
      updateTrackListings,
      fetchProductBundles,
      createSupplierCoupons
    } = actions

    return (
      <ContentWithSubSideBar
        subSideBar={(
          <SubSideBar
            onClick={this.handleAnchorClick}
          />
        )}
      >
        <section
          ref={this.dashboardArea}
          className={styles.dashboardArea}
        >
          <div
            key='operatingDashboard'
            className={styles.operatingDashboard}
          >
            <Section
              anchor={ANCHOR_MAP.SALE_RANKING}
              component={SaleRanking}
              fetchRankingsStats={fetchRankingsStats}
              minHeight={233}
            />
            <Section
              anchor={ANCHOR_MAP.SALES_PERFORMANCE}
              component={SalesPerformance}
              sharedLink={sharedLink}
              fetchSalesPerformances={fetchSalesPerformances}
              fetchPaginationBestsellers={fetchPaginationBestsellers}
              sendDashboardPageview={this.sendDashboardPageview}
              minHeight={624}
            />
            <Section
              anchor={ANCHOR_MAP.SALE_STAT}
              component={SaleStat}
              saleStat={saleStat}
              updateSaleStatSettings={updateSaleStatSettings}
              fetchSaleStats={fetchSaleStats}
              fetchSaleStatsByDate={fetchSaleStatsByDate}
              fetchOrderCategoryDistribution={fetchOrderCategoryDistribution}
              fetchPaginationBestsellers={fetchPaginationBestsellers}
              fetchListingPageViews={fetchListingPageViews}
              sendDashboardPageview={this.sendDashboardPageview}
            />
            <Section
              anchor={ANCHOR_MAP.BESTSELLER_RANKING}
              component={BestsellerRanking}
              sharedLink={sharedLink}
              fetchPaginationBestsellers={fetchPaginationBestsellers}
              sendDashboardPageview={this.sendDashboardPageview}
              minHeight={387}
            />
            <Section
              anchor={ANCHOR_MAP.CUSTOMER_INTEREST}
              component={CustomerInterest}
              sharedLink={sharedLink}
              fetchAbandonedCarts={fetchAbandonedCarts}
              fetchArrivalNoticeSummaries={fetchArrivalNoticeSummaries}
              fetchListingTags={fetchListingTags}
              fetchListings={fetchListings}
              fetchProductBundles={fetchProductBundles}
              createSupplierCoupons={createSupplierCoupons}
              minHeight={237}
              sendDashboardPageview={this.sendDashboardPageview}
              flags={flags}
              page={page}
            />
            <Section
              anchor={ANCHOR_MAP.PAGE_VIEWS_ANALYSIS}
              component={PageViewsAnalysis}
              fetchListingPageViews={fetchListingPageViews}
              fetchSaleStatsByDate={fetchSaleStatsByDate}
              sendDashboardPageview={this.sendDashboardPageview}
              minHeight={830}
              flags={flags}
            />
            <Section
              anchor={ANCHOR_MAP.SEARCH_KEYWORDS}
              component={SearchKeywords}
              fetchSearchKeywords={fetchSearchKeywords}
              fetchSpecificSearchKeywordListings={fetchSpecificSearchKeywordListings}
              sendDashboardPageview={this.sendDashboardPageview}
              minHeight={428}
            />
            <Section
              anchor={ANCHOR_MAP.MEMBER_ANALYSES}
              component={MemberAnalyses}
              fetchMemberAnalyses={fetchMemberAnalyses}
              sendDashboardPageview={this.sendDashboardPageview}
              minHeight={428}
            />
            <Section
              anchor={ANCHOR_MAP.BRAND_ANALYSIS}
              component={BrandAnalysis}
              fetchBrandDistribution={fetchBrandDistribution}
              fetchBrandDistributionByBrandId={fetchBrandDistributionByBrandId}
              sendDashboardPageview={this.sendDashboardPageview}
              minHeight={321}
            />
            <Section
              anchor={ANCHOR_MAP.RETURNS_ANALYSIS}
              component={ReturnsAnalysis}
              fetchReturns={fetchReturns}
              fetchReturnReasonSummaries={fetchReturnReasonSummaries}
              fetchSpecificReturnReasonsListings={fetchSpecificReturnReasonsListings}
              sendDashboardPageview={this.sendDashboardPageview}
              minHeight={566}
            />
            <Section
              anchor={ANCHOR_MAP.CUSTOM_FOLLOW}
              component={CustomFollow}
              fetchListings={fetchListings}
              fetchPaginationBestsellers={fetchPaginationBestsellers}
              fetchReturns={fetchReturns}
              fetchAbandonedCarts={fetchAbandonedCarts}
              fetchListingTags={fetchListingTags}
              fetchTrackListings={fetchTrackListings}
              createTrackListings={createTrackListings}
              updateTrackListings={updateTrackListings}
              page={page}
              sharedLink={sharedLink}
              sendDashboardPageview={this.sendDashboardPageview}
              minHeight={400}
            />
            <Section
              anchor={ANCHOR_MAP.WAREHOUSE_OVERVIEW}
              component={WarehouseOverview}
              fetchWarehouseOverview={fetchWarehouseOverview}
              minHeight={500}
            />
            <DashboardReminder
              key='DashboardReminder'
            />
          </div>
          <Reminder />
        </section>
      </ContentWithSubSideBar>
    )
  }
}

export default createI13nNode(OperatingDashboard)
